import { MaintenanceAlert } from "components/common";
import { SearchWithFilter } from "components/search";

const UndersokelsesmetodePage = () => {
  return (
    <>
      <MaintenanceAlert />
      <SearchWithFilter />
    </>
  );
};

export default UndersokelsesmetodePage;
